export const CREHANA_LEGAL_AMPLITUDE_PAGE_NAME = 'Crehana Legal';
export const CREHANA_LEGAL_PAGE_KEY = 'crehana-legal';
